import { isValid } from '@/common/utils/validation/common.utils';
import { City } from '@/core/domain/address/models/cities-response.model';
import { Country } from '@/core/domain/address/models/countries-response.model';
import { Neighborhood } from '@/core/domain/address/models/neighborhoods-response.model';
import { State } from '@/core/domain/address/models/states-response.model';
import { ZipCode } from '@/core/domain/address/models/zipcodes-response.model';
import { Injectable } from '@angular/core';
import _ from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class AddressService {
    private _countries: Country[] = [];
    public get countries(): Country[] {
        return this._countries;
    }
    public set countries(v: Country[]) {
        this._countries = v;
    }

    private _country: string | null = null;
    public getCountry(countryId: number | null = null): string | null {
        this.country = this.getName(this.countries, countryId);
        return this._country;
    }
    public getCountryCode(countryId: number | null = null): string | null {
        this.country = this.getCode(this.countries, countryId);
        return this._country;
    }
    public set country(v: string | null) {
        this._country = v;
    }

    private _states: State[] = [];
    public get states(): State[] {
        return this._states;
    }
    public set states(v: State[]) {
        this._states = v;
    }

    private _state: string | null = null;
    public getState(stateId: number | null = null): string | null {
        this.state = this.getName(this.states, stateId);
        return this._state;
    }
    public getStateCode(stateId: number | null = null): string | null {
        this.state = this.getCode(this.states, stateId);
        return this._state;
    }
    public set state(v: string | null) {
        this._state = v;
    }

    private _cities: City[] = [];
    public get cities(): City[] {
        return this._cities;
    }
    public set cities(v: City[]) {
        this._cities = v;
    }

    private _city: string | null = null;
    public getCity(cityId: number | null = null): string | null {
        this.city = this.getName(this.cities, cityId);
        return this._city;
    }
    public set city(v: string | null) {
        this._city = v;
    }

    private _neighborhoods: Neighborhood[] = [];
    public get neighborhoods(): Neighborhood[] {
        return this._neighborhoods;
    }
    public set neighborhoods(v: Neighborhood[]) {
        this._neighborhoods = v;
    }

    private _neighborhood: string | null = null;
    public getNeighborhood(cityId: number | null = null): string | null {
        this.neighborhood = this.getName(this.neighborhoods, cityId);
        return this._neighborhood;
    }
    public set neighborhood(v: string | null) {
        this._neighborhood = v;
    }

    private getName(items: unknown[], id: number | null): string | null {
        if (items.length > 0 && id !== null) {
            const item = _.find(
                items,
                (item: { id: number }) => item.id === id,
            ) as {
                name: string;
            };
            if (isValid(item)) {
                return _.toString(item.name);
            }
        }
        return null;
    }
    private getCode(items: unknown[], id: number | null): string | null {
        if (items.length > 0 && id !== null) {
            const item = _.find(
                items,
                (item: { id: number }) => item.id === id,
            ) as {
                code: string;
            };
            if (isValid(item)) {
                return _.toString(item.code);
            }
        }
        return null;
    }

    private _zipCodes: ZipCode[] = [];
    public get zipCodes(): ZipCode[] {
        return this._zipCodes;
    }
    public set zipCodes(v: ZipCode[]) {
        this._zipCodes = v;
    }

    private _zipCode: string | null = null;
    public getZipCode(neighborhoodId: number | null = null): string | null {
        if (this.neighborhoods.length > 0 && neighborhoodId !== null) {
            const neighborhood = _.find(
                this.neighborhoods,
                (item: Neighborhood) => item.id === neighborhoodId,
            );
            if (isValid(neighborhood)) {
                this.zipCode = _.toString(neighborhood?.zipCode).padStart(
                    5,
                    '0',
                );
            }
        }
        return this._zipCode;
    }
    public set zipCode(v: string | null) {
        this._zipCode = v;
    }
}
